import script from "./ComponentUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentUpload.vue?vue&type=script&setup=true&lang=js"

import "./ComponentUpload.vue?vue&type=style&index=0&id=2457a57a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2457a57a"]])

export default __exports__